import { cx } from "../../lib/cx.js";
/* empty css                   */
import { jsx } from "react/jsx-runtime";
//#region src/components/VisuallyHidden/VisuallyHidden.tsx
/** Hides content visually while keeping it available to assistive technology. */
function VisuallyHidden({ className, ...rest }) {
	return /* @__PURE__ */ jsx("span", {
		className: cx("ds-visually-hidden", className),
		...rest
	});
}
//#endregion
export { VisuallyHidden };

//# sourceMappingURL=VisuallyHidden.js.map